export default __webpack_public_path__ + "media/transfer-bubble/icon-error-85fa1e98.svg";